import { useEffect } from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, testId, hideClose = false }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="z-modal-backdrop" onClick={onClose} data-testid={testId || "modal"}>
      <div className="z-modal" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          {title && <h2 className="z-modal-title">{title}</h2>}
          {!hideClose && (
            <button
              onClick={onClose}
              data-testid="modal-close"
              style={{ background: "transparent", border: 0, cursor: "pointer", color: "var(--z-muted)", padding: 4 }}
              aria-label="Fermer"
            >
              <X size={22} />
            </button>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}
